export default {
  customer: "ACCOUNT_TYPE_CUSTOMER",
  garage: "ACCOUNT_TYPE_GARAGE"
};
